import { combineReducers } from 'redux'
import { NetworthAppState, NetworthSummaryTimeframe } from 'interfaces/networth'
import { createTimeframeReducer, createTrendModeReducer } from 'reducers/globalReducer'
import { Reducer } from 'interfaces'
import { GET_NETWORTH_SUMMARY, SET_NETWORTH_SUMMARY_RELATION, SET_NETWORTH_SUMMARY_TIMEFRAME } from 'actions/networthActions'
import { isSuccessAction } from 'helpers/actionsHelpers'

const DEFAULT_SUMMARY_STATE: NetworthAppState['summary'] = {
  relationId: null,
  timeframe: null,
}

const networthSummaryRelationIdReducer: Reducer<NetworthAppState['summary']['relationId']> =
  (state = DEFAULT_SUMMARY_STATE.relationId, action) => {
    switch (action.type) {
      case SET_NETWORTH_SUMMARY_RELATION:
        return action.payload.peergroup_relation

      case GET_NETWORTH_SUMMARY: {
        if (!isSuccessAction(action) || state) {
          return state
        }

        const { peergroup_rank } = action.payload.response.data
        if (!peergroup_rank) {
          return state
        }

        const relationIds = Object.keys(peergroup_rank)
        if (!relationIds.length) {
          return state
        }

        return Number(relationIds[0])
      }

      default:
        return state
    }
  }

const networthSummaryTimeframeReducer: Reducer<NetworthAppState['summary']['timeframe']> =
  (state = DEFAULT_SUMMARY_STATE.timeframe, action) => {
    if (action.type === SET_NETWORTH_SUMMARY_TIMEFRAME) {
      return action.payload.timeframe
    }

    if (action.type === GET_NETWORTH_SUMMARY && isSuccessAction(action) && !state) {
      const { delta } = action.payload.response.data
      if (!delta) {
        return state
      }

      const timeframes = Object.keys(delta) as NetworthSummaryTimeframe[]
      if (!timeframes.length) {
        return state
      }

      return timeframes[0]
    }

    return state
  }

const networthSummaryAppReducer = combineReducers<NetworthAppState['summary']>({
  relationId: networthSummaryRelationIdReducer,
  timeframe: networthSummaryTimeframeReducer,
})

const networthAppReducer = combineReducers<NetworthAppState>({
  summary: networthSummaryAppReducer,
  timeframe: createTimeframeReducer('networth'),
  trendMode: createTrendModeReducer('networth'),
})

export default networthAppReducer
